//
// HelpPage Manager

helpPageManager = (function () {
  var _swipeManager;
  var _helpPages;
  var _versionText;
  var _currentPageIndex;
  var _newPageIndex;
  var _fadeTimers;
  var _buttons;
  var _container;
  var _pageSwapDisable;
  var _fairnessText;
  var _maxWinInfoText;
  var _rtpInfoText;
  var _pageSwapSound;
  var _config;

  function create() {
    _container = new PIXI.Container();
    _swipeManager = undefined;
    _swipeFunctions = {
      left: undefined,
      right: undefined,
    };
    _helpPages = undefined;
    _versionText = undefined;
    _currentPageIndex = 0;
    _newPageIndex = -1;
    _fadeTimers = {
      show: 200,
      hide: 100,
      pageSwap: 100,
    };
    _buttons = {
      previous: undefined,
      close: undefined,
      next: undefined,
    };
    _container.open = open;
    _container.close = close;
    _container.alpha = 0;
    return _container;
  }

  function updateSwipeControls() {
    _manager.off('swipeleft', nextPage);
    _manager.off('swiperight', previousPage);

    switch (_currentPageIndex) {
      case _helpPages.length - 1:
        _manager.off('swipeleft', nextPage);
        _manager.on('swiperight', previousPage);
        break;
      case 0:
        _manager.on('swipeleft', nextPage);
        _manager.off('swiperight', previousPage);
        break;
      default:
        _manager.on('swipeleft', nextPage);
        _manager.on('swiperight', previousPage);
        break;
    }
  }

  function disableSwipeControls() {
    _manager.off('swipeleft', nextPage);
    _manager.off('swiperight', previousPage);
  }

  function open(startPage) {
    helpPageManager.stateMachine.switchState('SHOW');
    updateFairnessText();
    messageBus.post('game:modal', {
      reason: 'Options menu open',
      data: 'helpPageManager - open',
    });

    _currentPageIndex = startPage || 0;
    updateSwipeControls();
  }

  function close() {
    helpPageManager.stateMachine.switchState('HIDE');
    messageBus.post('game:modal', { data: 'helpPageManager - close' });
  }

  function nextPage() {
    if (helpPageManager.stateMachine.ActiveStateName === 'SWAP_PAGE') return;
    _newPageIndex = _currentPageIndex + 1;
    if (_newPageIndex + 1 >= _helpPages.length) {
      _buttons.next.visible = false;
    }

    _buttons.previous.visible = true;
    helpPageManager.stateMachine.switchState('SWAP_PAGE');
  }

  function previousPage() {
    if (helpPageManager.stateMachine.ActiveStateName === 'SWAP_PAGE') return;
    _newPageIndex = _currentPageIndex - 1;
    if (_newPageIndex <= 0) {
      _buttons.previous.visible = false;
    }

    _buttons.next.visible = true;
    helpPageManager.stateMachine.switchState('SWAP_PAGE');
  }

  function updateFairnessText() {
    var stake = resourceManager.getController('stakeController').CurrentStake;
    var stakeIndex = resourceManager.getController('stakeController').SelectedStakeIndex;

    if (_fairnessText) {
      var stakeStr = gdk.formatCurrency(stake);
      var maxWinStr = gdk.formatCurrency(_config.maxWins[stakeIndex]);
      var rtpStr = _config.RTP[stakeIndex];

      if (_fairnessText != undefined) {
        var fairnessText = resourceManager.get(_fairnessText);
        if (fairnessText) {
          fairnessText.setTranslationParameters(stakeStr, maxWinStr, rtpStr);
        }
      }

      if (_maxWinInfoText != undefined) {
        var maxWinInfoText = resourceManager.get(_maxWinInfoText);
        if (maxWinInfoText) {
          maxWinInfoText.setTranslationParameters(stakeStr, maxWinStr);
        }
      }

      if (_rtpInfoText != undefined) {
        var rtpInfoText = resourceManager.get(_rtpInfoText);
        if (rtpInfoText) {
          rtpInfoText.setTranslationParameters(stakeStr, rtpStr);
        }
      }
    } else {
      console.log("fairness Text not updated because it wasn't specified in json correctly");
    }
  }

  function parseGameConfig() {
    // if there are no help Pages return
    if (_helpPages === undefined) return;

    // Get the help pages
    for (var i = 0; i < _helpPages.length; ++i) {
      if (resourceManager.hasResource(_helpPages[i])) {
        _helpPages[i] = resourceManager.get(_helpPages[i]);
        _helpPages[i].alpha = 0;
        _helpPages[i].visible = false;
      } else {
        _helpPages[i] = undefined;
      }
    }
    _helpPages = _helpPages.filter(function (page) {
      return page !== undefined;
    });

    // Set the version number
    _versionText = resourceManager.get(_versionText);
    var versionStr =
      'v ' + gameData.gameVersionMajor + '.' + gameData.gameVersionMinor + '.' + gameData.gameVersionBugFix;
    if (gdk.getEngineVersion() !== '') {
      versionStr += ' - ' + gdk.getEngineVersion();
    }
    _versionText.setText(versionStr);

    // Only allow access to the console in developer mode
    /*
		if (gdk.isProductionBuild()) {
			_versionText.interactive = true;
			_versionText.mousedown = _versionText.touchstart = (function() {
				BPconsole.toggleShowConsole();
			});
		}
		 */

    // Get the buttons
    _buttons.previous = resourceManager.get(_buttons.previous);
    _buttons.close = resourceManager.get(_buttons.close);
    _buttons.next = resourceManager.get(_buttons.next);
    // Set button callbacks
    _buttons.previous.mousedown = _buttons.previous.touchstart = previousPage;
    _buttons.close.mousedown = _buttons.close.touchstart = close;
    _buttons.next.mousedown = _buttons.next.touchstart = nextPage;

    // creates the HammerJS object
    _manager = new Hammer.Manager(document.body);
    _manager.add(new Hammer.Swipe());
  }

  function update(delta) {
    if (helpPageManager.stateMachine) {
      helpPageManager.stateMachine.update();
    }
  }

  helpPageManager = {};
  StateMachine.Create(helpPageManager);

  helpPageManager.stateMachine.addState('IDLE', function () {});
  helpPageManager.stateMachine.addState('SHOW', function () {
    if (helpPageManager.phase.enter()) {
      _container.visible = true;
      _container.alpha = 0;
      _helpPages[_currentPageIndex].visible = true;

      _buttons.previous.visible = _currentPageIndex > 0;
      _buttons.next.visible = _currentPageIndex < _helpPages.length - 1;

      gdk.helpPageVisible(true);
    }
    if (helpPageManager.phase.timed(_fadeTimers.show)) {
      _container.alpha = helpPageManager.phase.Progress;
      _helpPages[_currentPageIndex].alpha = helpPageManager.phase.Progress;
    }
    if (helpPageManager.phase.once()) {
      helpPageManager.stateMachine.switchState('IDLE');
    }
    if (helpPageManager.phase.exit()) {
      _container.alpha = 1;
      _helpPages[_currentPageIndex].alpha = 1;
    }
  });

  helpPageManager.stateMachine.addState('SWAP_PAGE', function () {
    if (helpPageManager.phase.enter()) {
      _buttons.close.enableButton();
      _pageSwapDisable = true;
      soundManager.play(_pageSwapSound);

      _helpPages[_newPageIndex].alpha = 0;
      _helpPages[_newPageIndex].visible = true;
    }
    if (helpPageManager.phase.timed(_fadeTimers.pageSwap)) {
      _helpPages[_currentPageIndex].alpha = helpPageManager.phase.InverseProgress;
      _helpPages[_newPageIndex].alpha = helpPageManager.phase.Progress;
    }
    if (helpPageManager.phase.once()) {
      helpPageManager.stateMachine.switchState('IDLE');
    }
    if (helpPageManager.phase.exit()) {
      _helpPages[_currentPageIndex].alpha = 0;
      _helpPages[_currentPageIndex].visible = false;
      _helpPages[_newPageIndex].alpha = 1;
      _currentPageIndex = _newPageIndex;
      _newPageIndex = -1;
      _pageSwapDisable = false;
      updateSwipeControls();
    }
  });
  helpPageManager.stateMachine.addState('HIDE', function () {
    if (helpPageManager.phase.enter()) {
      _container.alpha = 1;
      _helpPages[_currentPageIndex].visible = true;
      _helpPages[_currentPageIndex].alpha = 1;
    }
    if (helpPageManager.phase.timed(_fadeTimers.hide)) {
      _container.alpha = helpPageManager.phase.InverseProgress;
      _helpPages[_currentPageIndex].alpha = helpPageManager.phase.InverseProgress;
    }
    if (helpPageManager.phase.once()) {
      helpPageManager.stateMachine.switchState('IDLE');
    }
    if (helpPageManager.phase.exit()) {
      _container.alpha = 0;
      _container.visible = false;
      gdk.helpPageVisible(false);
      _helpPages[_currentPageIndex].visible = false;
      _helpPages[_currentPageIndex].alpha = 0;
      disableSwipeControls();
    }
  });

  Reflex.addToUpdate(update);
  messageBus.subscribe('spinner:GameConfigEvent', parseGameConfig);

  function onGameConfigEvent(config) {
    _config = config.data.slotConfig;
  }

  function initialise(json, object) {
    _helpPages = json.helpPages;
    _versionText = json.versionText;

    _fadeTimers.show = json.showFadeTime || _fadeTimers.show;
    _fadeTimers.hide = json.hideFadeTime || _fadeTimers.hide;
    _fadeTimers.pageSwap = json.pageSwapFadeTime || _fadeTimers.pageSwap;
    _fairnessText = json.fairnessText;
    _maxWinInfoText = json.maxWinInfoText;
    _rtpInfoText = json.rtpInfoText;
    _buttons.previous = json.previousButton;
    _buttons.close = json.closeButton;
    _buttons.next = json.nextButton;
    _pageSwapSound = json.pageSwapSound || 'noSound';
    _container.visible = false;
  }

  function getFilesRequired() {
    return [];
  }

  messageBus.subscribe('spinner:GameConfigEvent', onGameConfigEvent);
  resourceManager.registerObjectType('helpPageManager', create, initialise, getFilesRequired);

  Object.defineProperties(helpPageManager, {
    create: {
      value: create,
    },
    initialise: {
      value: initialise,
    },
    getFilesRequired: {
      value: getFilesRequired,
    },
    nextPage: {
      value: nextPage,
    },
    previousPage: {
      value: previousPage,
    },
    pageSwapDisable: {
      get: function () {
        return _pageSwapDisable;
      },
    },
    showPopup: {
      get: function () {
        return open;
      },
      set: function (value) {
        open = value;
      },
    },
    close: {
      value: close,
    },
  });
  return helpPageManager;
})();
